<template>
  <div>
    <form-section
      :title="$t('PushSettingsTab_ChromeAndFirefoxTitle')"
      :description="$t('ApplicationForm_Row_PushNotificationSettingsInfo')"
    >
      <template slot="controls">
        <save-button :click="saveForm" />
      </template>
      <el-form :model="model" :disabled="readonly">
        <el-row>
          <el-col :span="6">
            <form-item
              prop="is_chrome"
              :label="$t('ApplicationForm_Field_Chrome')"
            >
              <toggle v-model="model.is_chrome" />
            </form-item>
          </el-col>
          <el-col :span="6">
            <form-item
              prop="is_firefox"
              :label="$t('ApplicationForm_Field_Firefox')"
            >
              <toggle v-model="model.is_firefox" />
            </form-item>
          </el-col>
        </el-row>
        <el-form :disabled="!model.is_chrome && !model.is_firefox">
          <el-row>
            <el-col :span="12">
              <form-item
                prop="webpush_domain_hosted"
                :label="$t('ApplicationForm_Field_DeploymentOptions')"
              >
                <radio-group v-model="model.webpush_domain_hosted">
                  <radio
                    :label="0"
                    :title="$t('ApplicationForm_Option_XtremepushHosted')"
                  />
                  <radio
                    :label="1"
                    :title="$t('ApplicationForm_Option_SelfHosted')"
                  />
                </radio-group>
              </form-item>
            </el-col>

            <el-col :span="12" v-if="!model.webpush_domain_hosted">
              <form-item
                prop="webpush_domain"
                :label="$t('ApplicationForm_Field_XpHostedDomain')"
              >
                <el-input v-model="model.webpush_domain">
                  <template slot="append">{{ model.providerDomain }}</template>
                </el-input>
              </form-item>
            </el-col>
          </el-row>
          <el-row v-if="model.chrome_sender_id">
            <el-col :span="12">
              <form-item
                prop="chrome_sender_id"
                :label="$t('ApplicationForm_Field_FCMGCMProject')"
              >
                <el-input v-model="model.chrome_sender_id" />
              </form-item>
            </el-col>
            <el-col :span="12">
              <form-item
                prop="new_chrome_key"
                :label="$t('ApplicationForm_Field_FCMGCMApi')"
              >
                <el-input
                  :placeholder="
                    model.chrome_key
                      ? $t('ApplicationForm_Placeholder_SavedApiKey')
                      : $t('ApplicationForm_Placeholder_NoApiKey')
                  "
                  v-model="model.new_chrome_key"
                />
              </form-item>
            </el-col>
          </el-row>
          <template v-if="model.webpush_domain_hosted">
            <el-row>
              <el-col :span="12">
                <form-item
                  prop="webpushServiceWorkerContent"
                  :label="$t('ApplicationSDKIntegration_ServiceWorker')"
                >
                  <el-input
                    :rows="6"
                    type="textarea"
                    v-model="model.webpushServiceWorkerContent"
                    disabled
                    autocomplete="off"
                  />
                </form-item>
              </el-col>
              <el-col :span="12">
                <form-item
                  prop="webpush_sw_url"
                  :label="$t('ApplicationSDKIntegration_ServiceWorkerURL')"
                >
                  <el-input v-model="model.webpush_sw_url" />
                </form-item>
                <p>{{ $t('ApplicationSDKIntegration_SWUrlHint') }}</p>
              </el-col>
            </el-row>
            <el-row v-if="model.chrome_sender_id">
              <el-col :span="12">
                <form-item
                  prop="webpushManifestContent"
                  :label="$t('ApplicationSDKIntegration_Manifest')"
                >
                  <el-input
                    :rows="6"
                    type="textarea"
                    v-model="model.webpushManifestContent"
                    disabled
                    autocomplete="off"
                  />
                </form-item>
              </el-col>
              <el-col :span="12">
                <form-item
                  prop="webpush_manifest_url"
                  :label="$t('ApplicationSDKIntegration_ManifestURL')"
                >
                  <el-input v-model="model.webpush_manifest_url" />
                </form-item>
                <p>{{ $t('ApplicationSDKIntegration_ManifestUrlHint') }}</p>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <form-item
                  prop="webpush_window_mode"
                  :label="$t('ApplicationForm_Field_UseSubscribeWindow')"
                >
                  <enum-select
                    v-model="model.webpush_window_mode"
                    :options="WindowTypes"
                    :number="true"
                  />
                </form-item>
              </el-col>
            </el-row>
            <el-row v-if="model.webpush_window_mode">
              <el-col :span="12">
                <form-item
                  prop="webpushWindowContent"
                  :label="$t('ApplicationSDKIntegration_Subscribe')"
                >
                  <el-input
                    :rows="6"
                    type="textarea"
                    v-model="model.webpushWindowContent"
                    disabled
                    autocomplete="off"
                  />
                </form-item>
              </el-col>
              <el-col :span="12">
                <form-item
                  prop="webpush_window_url"
                  :label="$t('ApplicationSDKIntegration_SubscribeURL')"
                >
                  <el-input v-model="model.webpush_window_url" />
                </form-item>
                <p>{{ $t('ApplicationSDKIntegration_SubscribeUrlHint') }}</p>
              </el-col>
            </el-row>
            <el-row v-if="model.webpush_window_mode">
              <el-col :span="12">
                <form-item
                  prop="webpushFrameContent"
                  :label="$t('ApplicationSDKIntegration_Frame')"
                >
                  <el-input
                    :rows="6"
                    type="textarea"
                    v-model="model.webpushFrameContent"
                    disabled
                    autocomplete="off"
                  />
                </form-item>
              </el-col>
              <el-col :span="12">
                <form-item
                  prop="webpush_window_url"
                  :label="$t('ApplicationSDKIntegration_FrameURL')"
                >
                  <el-input v-model="model.webpush_frame_url" />
                </form-item>
                <p>{{ $t('ApplicationSDKIntegration_FrameUrlHint') }}</p>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </el-form>
    </form-section>

    <form-section
      :title="$t('PushSettingsTab_AppleTitle')"
      :description="$t('ApplicationForm_Row_PushNotificationSettingsInfo')"
    >
      <template slot="controls">
        <save-button :click="saveForm" />
      </template>
      <el-form :model="model">
        <el-row>
          <el-col :span="12">
            <form-item
              prop="is_safari"
              :label="$t('ApplicationForm_Field_Safari')"
            >
              <toggle v-model="model.is_safari" />
            </form-item>
            <form-item
              prop="safari_push_id"
              :label="$t('ApplicationForm_Field_WebPushId')"
            >
              <el-input
                v-model="model.safari_push_id"
                :disabled="!model.is_safari"
              />
            </form-item>

            <form-item
              prop="safari_key_file"
              :label="$t('ApplicationForm_Field_PushCertificate')"
              :hint="certExpiryDate"
            >
              <certificate-upload
                :value="model.safari_key"
                :file.sync="model.safari_key_file"
                :password.sync="model.safari_key_password"
                :disabled="!model.is_safari"
              />
            </form-item>
          </el-col>
        </el-row>
      </el-form>
    </form-section>

    <form-section
      :title="$t('PushSettingsTab_SdkSettings_Title')"
      :description="$t('PushSettingsTab_SdkSettings_Desc')"
    >
      <template slot="controls">
        <save-button :click="saveForm" />
      </template>
      <el-form :model="model">
        <el-row>
          <el-col>
            <form-item
              prop="auto_prompt"
              :label="$t('ApplicationSDKSetting_AutoPromptPermissionDialog')"
            >
              <toggle v-model="model.auto_prompt" />
            </form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <form-item
              prop="auto_prompt_start"
              :label="$t('ApplicationSDKSetting_PromptAt')"
            >
              <el-input v-model="model.auto_prompt_start">
                <template slot="append">
                  {{ $t('ApplicationSDKSetting_pageview') }}
                </template>
              </el-input>
            </form-item>
            <form-item
              prop="auto_prompt_repeat"
              :label="$t('ApplicationSDKSetting_IfNoRepeatAfter')"
            >
              <el-input v-model="model.auto_prompt_repeat">
                <template slot="append">
                  {{ $t('ApplicationSDKSetting_pageview') }}
                </template>
              </el-input>
            </form-item>
            <form-item
              prop="auto_prompt_description"
              :label="$t('ApplicationSDKSetting_CustomMessage')"
            >
              <el-input
                v-model="model.auto_prompt_description"
                type="textarea"
              />
            </form-item>
          </el-col>
          <el-col :span="12">
            <form-item
              prop="auto_prompt_allow_redirect"
              :label="$t('ApplicationSDKSetting_IfYesRedirectTo')"
            >
              <el-input v-model="model.auto_prompt_allow_redirect" />
            </form-item>
            <form-item
              prop="auto_prompt_block_redirect"
              :label="$t('ApplicationSDKSetting_IfNoRedirectTo')"
            >
              <el-input v-model="model.auto_prompt_block_redirect" />
            </form-item>
            <form-item
              prop="auto_prompt_dismiss_redirect"
              :label="$t('ApplicationSDKSetting_IfDismissRedirectTo')"
            >
              <el-input v-model="model.auto_prompt_dismiss_redirect" />
            </form-item>
          </el-col>
        </el-row>
      </el-form>
    </form-section>
  </div>
</template>

<script>
import { WindowTypes } from '@/modules/account/enum/WindowTypes'
import FormItem from '@/common/components/form/FormItem'
import Toggle from '@/common/components/form/Toggle'
import EnumSelect from '@/common/components/form/EnumSelect'
import SaveButton from '@/common/components/form/SaveButton'
import FormSection from '@/common/components/form/FormSection'
import CertificateUpload from '@/common/components/form/CertificateUpload'
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
import moment from 'moment'
export default {
  name: 'PushSettingsWeb',
  components: {
    Radio,
    RadioGroup,
    CertificateUpload,
    FormSection,
    SaveButton,
    EnumSelect,
    Toggle,
    FormItem
  },
  data() {
    return {
      WindowTypes
    }
  },
  props: {
    model: {
      required: true,
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    },
    save: {
      type: Function,
      required: true
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm'
    }
  },
  methods: {
    saveForm() {
      this.save()
    }
  },
  computed: {
    certExpiryDate() {
      if (!this.model.safariCertificateExpiryDate) {
        return
      }

      return this.$t('PushSettingsTab_ExpiryDate', {
        date: moment
          .unix(this.model.safariCertificateExpiryDate)
          .format(this.dateFormat)
      })
    }
  },
  watch: {
    'model.webpush_domain_hosted': {
      handler() {
        if (
          (this.model.is_chrome || this.model.is_firefox) &&
          this.model.webpush_domain_hosted &&
          !this.model.webpushServiceWorkerContent
        ) {
          this.save() // Generate Web SDK package
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
p {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/PushSettingsWeb.vue